import { observer } from "mobx-react-lite";
import React from "react";

import Svg from "../../../components/svg/Svg";
import { Email, Address, TelFax } from "../../../components/svg/svgImageList";
import { TermsAndConditions } from "../../../components/terms-and-conditions/TermsAndConditions";
import { translationService } from "../../../services/translation/TranslationService";
import "./composition.scss";
import { Box } from "@mui/material";

interface StaticInfoProps {
  svg: React.FunctionComponent;
  descriptionKey: string;
}

export const HelpContact = observer(() => {
  return (
    <div  className="help-contact-container">
      <div style={{ textAlign: 'center' }} className="contact-title">{translationService.translate("HelpPage.contact.title")}</div>
      <div>
        <div style={{ textAlign: 'center' }} className="contact-text">{translationService.translate("HelpPage.contact.text")}</div>
        <TermsAndConditions />
      </div>
      <div className="contact-details">
        <Box sx={{margin: {xs: "0 auto 0 0", sm: "0 0 0 0"}}}>
          <StaticInfo svg={Address} descriptionKey="general.contact.address" />
        </Box>
        <Box sx={{margin: {xs: "0 auto 0 0", sm: "0 0 0 0"}}}>
          <StaticInfo svg={TelFax} descriptionKey="general.contact.telFax" />
        </Box>
      </div>
    </div>
  );
});

const StaticInfo = (props: StaticInfoProps) => {
  const { svg, descriptionKey } = props;
  return (
    <div className="static-info-item">
      <Svg svg={svg} width={50} height={50} />
      <pre>{translationService.translate(descriptionKey)}</pre>
    </div>
  );
};
